import { Card, Collapse, List, ListItem, ListItemText } from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import * as api from "api/Core";
import { RequestIndicator, SpinnerIndicator } from "components/CallServer";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import Session from "services/Session";
import { WithTranslation, withTranslation } from "react-i18next";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import { Formaters } from "lib/Formarters";

/////////////////////////////////////////////////////////////////////////////////////

interface IData {
    releaseNumber: string;
    releaseDate: Date;
    releaseNotes: string;
    open: boolean;
}

interface IState {
    data: IData[];
    loading: boolean;
    lastError: any;
}

type Props = WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ReleaseNotes extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            lastError: null
        };
    }

    ///
    private load() {
        api.getReleaseNotes()
            .then((result) => {
                this.setState({
                    data: result.map((v) => {
                        return {
                            open: v.releaseNumber == Session.appVersion,
                            releaseDate: v.releaseDate,
                            releaseNumber: v.releaseNumber
                        } as IData;
                    }),
                    loading: false
                }, () => {
                    this.loadReleaseNote(Session.appVersion);
                });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false, lastError: error });
            });
    }

    ///
    private loadReleaseNote(releaseNumber: string) {
        api.getReleaseNote(releaseNumber)
            .then((result) => {

                this.setState((state) => {
                    var data = state.data.slice(0);
                    var d = data.find(x => x.releaseNumber == releaseNumber);
                    if (d) d.releaseNotes = result;
                    return { ...state, data };
                });

            })
            .catch((error) => {
                this.setState({ data: null, loading: false, lastError: error });
            });
    }

    ///
    private handleClick(releaseNumber: string) {
        this.setState((state) => {
            var data = state.data.slice(0);
            var d = data.find(x => x.releaseNumber == releaseNumber);
            if (d) {
                d.open = !d.open;
                if (d.releaseNotes == null) this.loadReleaseNote(releaseNumber);
            }
            return { ...state, data };
        });
    }

    /////////////////////////////////////////////////////////////////////////////////////

    componentDidMount() {
        this.load();
    }

    render() {
        const { loading, lastError, data } = this.state;
        return (
            <div>
                {
                    lastError
                        ? <RequestErrorReport error={this.state.lastError} />
                        : loading
                            ? <RequestIndicator type="waiting" />
                            : (
                                <div>
                                    <MuiContainer>
                                        <CardHeaderColor color="info" title={this.props.t("Views.Public.ReleaseNotes.Title")} />
                                    </MuiContainer>

                                    {
                                        data.map((v) => {
                                            return (
                                                <MuiContainer margin="dense">
                                                    <Card>
                                                        <List component="nav">
                                                            <ListItem button onClick={() => this.handleClick(v.releaseNumber)}>
                                                                <ListItemText primary={<span><b>{v.releaseNumber}</b> ({Formaters.localeDate(v.releaseDate)})</span>} />
                                                                {v.open ? <ExpandLess /> : <ExpandMore />}
                                                            </ListItem>
                                                            <Collapse in={v.open} timeout="auto" unmountOnExit>
                                                                <ListItem>
                                                                    {
                                                                        v.releaseNotes == null
                                                                            ? <SpinnerIndicator />
                                                                            : <pre>{v.releaseNotes}</pre>
                                                                    }
                                                                </ListItem>
                                                            </Collapse>
                                                        </List>
                                                    </Card>
                                                </MuiContainer>
                                            );
                                        })
                                    }
                                </div>
                            )
                }

            </div>
        );
    }
}

export default withTranslation()(ReleaseNotes);
